import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import Header from '../common/template/header';
import SideBar from '../common/template/sideBar';
import Footer from '../common/template/footer';
import Messages from '../common/msg/messages';
import imagemLogo from '../assets/images/logo_criatec_branco.png';
import imagemFundo from '../assets/images/splash/fundo.png';
import imagemBemVindo from '../assets/images/splash/bemvindo.png';

import Routes from './routes';

class App extends Component {

	state = {
		carregando: true
	}

	constructor(props) {
		super(props);

		setTimeout(() => {
			this.setState({ ...this.state, carregando: false })
		}, 2000);
    }

	render() {
		
		return (
			<HashRouter>
				{this.state.carregando ?
					<div style={{ display: 'flex', alignItems: 'center', height: '100vh', backgroundSize: 'cover', background: 'linear-gradient(to bottom, #379DE2, #19CCCC)' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column', 
								justifyContent: 'center',
								alignItems: 'center',
								height: '100%',
								width: '100%',
								backgroundImage: `url(${imagemFundo})`,
								backgroundSize: 'cover',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center'
							}}>
							<img src={imagemLogo} style={{ width: 200, height: 'auto' }} />

							<img src={imagemBemVindo} style={{ width: 200, height: 'auto', marginTop: 50 }} />
						</div>
					</div>
				:
					<div className='wrapper'>
						<Header />
						{/* <SideBar /> */}
						<Routes administrador={this.props.sessao ? this.props.sessao.administrador : false} />
						<Messages />
					</div>
				}
			</HashRouter>
		);
	}
}


const mapStateToProps = state => ({
	sessao: state.auth.usuario
});
export default connect(mapStateToProps, null)(App);
